import { Space, Typography } from 'antd';
import React from 'react';
import { FieldFilter } from 'components/organisms/tasks/filters';
import { ValueRenderer } from './value-renderer';

const { Text } = Typography;

export const SelectedConditions = ({
  criteria = [],
  customOptionTrigger,
}: {
  criteria?: FieldFilter[];
  customOptionTrigger?: boolean;
}) => {
  return (
    <Space direction="vertical">
      {criteria.map((each) => (
        <Space key={each.field.fieldId}>
          <Text strong>{each.field.fieldName}</Text>
          <ValueRenderer
            selected={each}
            customOptionTrigger={customOptionTrigger}
          />
        </Space>
      ))}
    </Space>
  );
};
